"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cart = void 0;
var react_1 = __importDefault(require("react"));
var useCart_1 = require("../hooks/useCart");
function Euro(_a) {
    var amount = _a.amount;
    return react_1.default.createElement(react_1.default.Fragment, null,
        "\u20AC ",
        amount.toFixed(2).replace(".", ","));
}
function Cart(_a) {
    var state = _a.state;
    var _b = (0, useCart_1.useCart)(), cart = _b.cart, count = _b.count, deleteTraining = _b.deleteTraining;
    var hideMarks = !state;
    var _c = state !== null && state !== void 0 ? state : [[], function () { }], marks = _c[0], setMarks = _c[1];
    var handleMark = function (index) { return function (e) {
        setMarks(function (marks) { return __spreadArray(__spreadArray(__spreadArray([], marks.slice(0, index), true), [
            e.target.value
        ], false), marks.slice(index + 1), true); });
    }; };
    var span = hideMarks ? 3 : 4;
    return (react_1.default.createElement(react_1.default.Fragment, null, cart && (react_1.default.createElement(react_1.default.Fragment, null,
        !count && (react_1.default.createElement("div", { className: "alert alert-warning" }, "Er zijn nog geen trainingen aan de winkelwagen toegevoegd.")),
        !!count && (react_1.default.createElement("table", { className: "table mt-3" },
            react_1.default.createElement("tbody", null,
                cart.trainingen.map(function (training, index) {
                    return (react_1.default.createElement("tr", { key: training.ID },
                        react_1.default.createElement("td", { className: "border-0" },
                            react_1.default.createElement("strong", null, training.vak),
                            " ",
                            training.niveau),
                        !hideMarks && (react_1.default.createElement("td", { className: "border-0" },
                            react_1.default.createElement("input", { type: "text", pattern: "[0-9]+([,\\.][0-9]+)?", className: "form-control", placeholder: "SE Cijfer", required: true, value: marks[index] || "", onChange: handleMark(index) }))),
                        react_1.default.createElement("td", { className: "border-0" }, training.tbdRemark ||
                            training.showDate),
                        react_1.default.createElement("td", { className: "border-0" }, training.naam),
                        react_1.default.createElement("td", { className: "border-0 text-right" },
                            react_1.default.createElement(Euro, { amount: training.prijs })),
                        react_1.default.createElement("td", { className: "border-0" },
                            react_1.default.createElement("button", { type: "button", className: "btn btn-blue btn-sm actionButton", onClick: function () {
                                    return deleteTraining(training);
                                } },
                                react_1.default.createElement("i", { className: "fas fa-trash", "aria-hidden": "true" })))));
                }),
                cart.ltrainingen.map(function (training) {
                    return (react_1.default.createElement("tr", { key: training.ID },
                        react_1.default.createElement("td", { className: "border-0" },
                            react_1.default.createElement("strong", null, "Light"),
                            " ",
                            training.soort),
                        !hideMarks && (react_1.default.createElement("td", { className: "border-0" })),
                        react_1.default.createElement("td", { className: "border-0" }, training.tbdRemark ||
                            training.showDate),
                        react_1.default.createElement("td", { className: "border-0" }, training.naam),
                        react_1.default.createElement("td", { className: "border-0 text-right" },
                            react_1.default.createElement(Euro, { amount: training.prijs })),
                        react_1.default.createElement("td", { className: "border-0" },
                            react_1.default.createElement("button", { type: "button", className: "btn btn-blue btn-sm actionButton", onClick: function () {
                                    return deleteTraining(training);
                                } },
                                react_1.default.createElement("i", { className: "fas fa-trash", "aria-hidden": "true" })))));
                }),
                cart.korting > 0 && (react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", { colSpan: span, className: "border-0" },
                        "Korting ivm 2 dagen Intensive Examentraining (",
                        react_1.default.createElement(Euro, { amount: cart.kortingperdag }),
                        " ",
                        "per dag)"),
                    react_1.default.createElement("td", { className: "border-0 text-right" },
                        react_1.default.createElement(Euro, { amount: -cart.korting })),
                    react_1.default.createElement("td", { className: "border-0" }))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", { colSpan: span, className: "border-top" },
                        react_1.default.createElement("strong", null, "Totaal")),
                    react_1.default.createElement("td", { className: "border-top text-right" },
                        react_1.default.createElement("strong", null,
                            react_1.default.createElement(Euro, { amount: cart.totaalprijs }))),
                    react_1.default.createElement("td", { className: "border-top" })))))))));
}
exports.Cart = Cart;
